import React, {useEffect} from "react";
import { Outlet } from "react-router-dom";
import useAppUrl from "../../../hooks/useAppUrl";
import { MainContainer } from "./Layout.style";
import { ContentContainer } from "./Layout.style";

const SLGLLayout = () => {
  const { appPath, setAppPath, appName, setAppName } = useAppUrl();
  useEffect(() => {
    setAppName("СЛГЛ");
    setAppPath("/slgl");
  }, [])
  
  return (
    <>
      <MainContainer>
          <Outlet />
      </MainContainer>
    </>
  );
};

export default SLGLLayout;
